import { render, staticRenderFns } from "./teacherResult.vue?vue&type=template&id=769b85db&scoped=true&"
import script from "./teacherResult.js?vue&type=script&lang=js&"
export * from "./teacherResult.js?vue&type=script&lang=js&"
import style0 from "./teacherResult.vue?vue&type=style&index=0&id=769b85db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769b85db",
  null
  
)

export default component.exports